var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaundry = function SvgLaundry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M18.75 1.5H5.25A2.25 2.25 0 0 0 3 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25m-3 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-10.5.75A.75.75 0 0 1 6 3.75h2.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M12 20.25a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6m6-15a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M12.024 14.25a5 5 0 0 0-4.523.013 4.5 4.5 0 1 0 9-.005 5 5 0 0 1-4.478-.008"
  })));
};
export default SvgLaundry;